import { render, staticRenderFns } from "./PlatformsSwitch.vue?vue&type=template&id=5cbd72ca&"
import script from "./PlatformsSwitch.vue?vue&type=script&lang=js&"
export * from "./PlatformsSwitch.vue?vue&type=script&lang=js&"
import style0 from "./PlatformsSwitch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports